/*jshint esversion: 6 */

function isDevEnv(){
  if (process.env.NODE_ENV == 'development') {
    return true;
  }
  return false;
}

module.exports = {
  isDevEnv: isDevEnv()
};
